import { getAnimatedElementData } from "lib/designUtils";
import { ANIMATION_DURATION } from "lib/animationUtils";

// need to use camelCase conversion here as these keys can be converted to camelCase
// and starting them as camelCase just keeps it consistent
export const getAnimationDataKey = ({ uniqueId, domId = "" }) =>
  `${uniqueId}${domId ? `-${domId}` : ""}`;

/**
 * @desc Takes in any element and returns extracted animation data for it
 * @param {object} element - the element to gather animation data for
 * @returns an array of animation data including the duration for the animated content
 */
export const getAnimationData = element => {
  let animationData = [];
  const animatedElementData = getAnimatedElementData(element);

  if (animatedElementData) {
    animationData = [animatedElementData];
  }

  // get imageInstruction data for every indiividual image in the element
  // pass each imageInstruction to be checked for animated duration property
  if (element.hasOwnProperty("imageInstructions")) {
    const animatedImageInstructionData = element.imageInstructions.map(
      imageInstruction => {
        const animatedImageInstructions =
          getAnimatedElementData(imageInstruction);

        if (animatedImageInstructions) {
          return animatedImageInstructions;
        }
        return null;
      }
    );
    const animatedImageInstructions = animatedImageInstructionData.filter(
      x => x
    );
    if (animatedImageInstructions.length > 0) {
      if (!!element.cssAnimation) {
        // Handle both array and object formats for cssAnimation
        let cssAnimationDuration;
        if (Array.isArray(element.cssAnimation)) {
          // For array format, calculate the total duration of all animations
          const maxEndTime = element.cssAnimation.reduce((max, anim) => {
            const animEndTime = (anim.delay || 0) + ANIMATION_DURATION;
            return Math.max(max, animEndTime);
          }, 0);
          cssAnimationDuration = maxEndTime;
        } else {
          // Legacy single animation object format
          cssAnimationDuration =
            (element.cssAnimation.delay || 0) + ANIMATION_DURATION;
        }
        const maxDuration = animatedImageInstructions.reduce((max, current) => {
          return Math.max(max, current.duration);
        }, 0);
        if (cssAnimationDuration > maxDuration) {
          animatedImageInstructions.forEach(instruction => {
            instruction.duration = cssAnimationDuration;
          });
        }
      }
      animationData = animatedImageInstructions;
    }
  }

  // ensure that the uniqueId and animationDataKey are added to our dataPoints
  return animationData.map(dataPoint => ({
    // ...dataPoint,
    duration: Math.round(dataPoint.duration),
    domId: dataPoint.domId,
    uniqueId: element.uniqueId,
    pageId: element.pageId,
    groupId: element.groupId,
    animationDataKey: getAnimationDataKey({
      uniqueId: element.uniqueId,
      domId: dataPoint.domId
    })
  }));
};
